import { css, styled, thd, up } from '@smooth-ui/core-sc';
import { NavLink } from 'react-router-dom';

export default styled(NavLink)`
  border-left: 3px solid transparent;
  color: #fff;
  display: block;
  font-size: 20px;
  font-weight: normal;
  //font-variation-settings: 'wght' 550;
  padding: 0.5em;
  ${props =>
    props.depth && props.depth > 1 && `padding-left: ${props.depth - 1}em;`}
  text-decoration: none;

  &:hover {
    color: ${thd('customMenuHighlightColor', '#000')};
  }

  &:visited {
    color: ${thd('customMenuHighlightColor', '#000')};
  }

  &.menu-active {
    border-left-color: ${thd('customMenuHighlightColor', '#54707c')};
    color: ${thd('customMenuHighlightColor', '#000')};
    font-weight: bold;
  }

  ${up(
    'lg',
    css`
      font-size: 18px;
      font-weight: normal;
      color: #fff;
      ${props =>
        // If it's the top level
        (!props.depth || props.depth < 2) &&
        css`
          border-left: 0 none;
          border-bottom: 5px solid transparent;
          margin-left: 1.2rem;
          margin-right: 1.2rem;
          padding: 0.25em 0.2em;
        `}

      &:hover {
        border-bottom: 5px solid #fff;
      }

      &.menu-active {
        border-bottom: 5px solid #fff;
        &:hover {
          color: ${thd('customMenuHighlightColor', '#000')};
        }
      }
    `
  )}
`;
